<template>

  <div id="app">
    <v-overlay :value="isLoading" key="overlay-loading">
      <v-progress-circular
        indeterminate
        color="red"
      ></v-progress-circular>
    </v-overlay>
    <router-view/>

  </div>
</template>

<script>

  import config from './../config.js'

  export default {
    metaInfo : {
      title: config.title
    },
    data () {
      return {
        loading:  this.$store.state.is_loading,
        
      }
    },
    computed: {
      isLoading: function() {
        return this.$store.state.is_loading;
      }
    }
  }
</script>

<style lang="scss">
@font-face {
  font-family: "SukhumvitSet";
  src: local("SukhumvitSet"),
   url(./assets//SukhumvitSet.ttf) format("truetype");
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
